<app-image-panel [formService]="itemView['dynamicFormService']"></app-image-panel>
<ntap-prime-common-itemview #itemView></ntap-prime-common-itemview>